import { ReactElement } from 'react';
import { createProfitArray, interestGraphOptions } from '../utils';
import InterestGraphBase from './InterestGraphBase';

const profitData = createProfitArray(7, 80, 20, 80, false);
const textPath = {
  title: 'course2.part3.interest_example_graph_3.title',
  subtitle: 'course2.part3.interest_example_graph_3.subtitle',
  altText: 'course2.part3.interest_example_graph_3.alt_text',
  estimatedSave: 'course2.part3.interest_example_graph_3.estimated_save',
  sources: 'course2.part3.interest_example_graph_3.sources',
};
const specs = {
  investmentAmount: 80,
  accountSavings: undefined,
  profitExpected: 7,
  investmentTime: 20,
};

const InterestGraph3 = (): ReactElement => {
  const options = interestGraphOptions(profitData);
  return <InterestGraphBase options={options} text={textPath} specs={specs} />;
};

export default InterestGraph3;
